<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-back-button slot="start"></ion-back-button>
        <ion-title>{{ getEnv('APP_NAME') }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div id="entry-parent" :class="randomBack()">
        <div id="content-box">
          <LoginContainer />
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, isPlatform, IonHeader, IonToolbar, IonBackButton, IonTitle } from '@ionic/vue';
import '../theme/signup.css';
import LoginContainer from '@/components/LoginContainer.vue';
import getEnv from '@/utils/env'

export default {
  name: "UserLogin",
  components: { IonContent, IonPage, LoginContainer, IonHeader, IonToolbar, IonBackButton, IonTitle },
  data() {
    return {
      username: '',
      password: '',
      error: '',
      loadingIndicator: '',
      backVal: 1
    }
  },
  mounted() {
    if(getEnv('APP_NAME') == 'ChoiceSocial'){
      this.backVal = Math.floor(Math.random() * (7 - 1) + 1);
    }
  },
  methods: {
    randomBack() {
      return 'background-' + this.backVal;
    }
  },
  setup() {
    return {
      isPlatform,
      LoginContainer,
      getEnv
    }
  },
};
</script>
